module.exports = __webpack_public_path__ + "static/img/VideoMarketing.e72b926.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/VideoMarketing.jpg
// module id = lfGP
// module chunks = 1